import React, { ElementType, FC, ReactNode } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import styled from 'styled-components'

interface LinkRendererProps {
  children: ReactNode
  href: string
}

const Link = styled.a`
  color: ${({ theme }) => theme.colors.primary}!important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
  display: inline;
`

const LinkRenderer: FC<LinkRendererProps> = ({ children, href }) => {
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  )
}

const CustomMarkdown = ({ children }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{ a: LinkRenderer as ElementType }}
    >
      {children}
    </ReactMarkdown>
  )
}

export default CustomMarkdown
